export const THEME_STORAGE_KEY = 'finanzk.ui_theme'

export type Theme = 'light' | 'dark'

function isTheme(value: string | null): value is Theme {
    return value === 'light' || value === 'dark'
}

export function getCachedTheme(): Theme | null {
    const value = window.localStorage.getItem(THEME_STORAGE_KEY)
    return isTheme(value) ? value : null
}

export function applyTheme(theme: Theme): void {
    if (theme === 'dark') {
        document.documentElement.classList.add('dark-mode')
    } else {
        document.documentElement.classList.remove('dark-mode')
    }
}

export function cacheTheme(theme: Theme): void {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme)
}

export function setTheme(theme: Theme): void {
    cacheTheme(theme)
    applyTheme(theme)
}
